<template>
	<div class="view-review">
		<Modal
			:show="showListReview"
			content_class="col-12 col-md-8 col-lg-6 col-xl-5 confirm-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">{{ title }}</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showListReview', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<Review
								v-for="(review, i) of product_reviews"
								:key="i"
								:review="review"
							/>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: 'Product Reviews',
		},
	},
	components: {
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('@/components/newportal/templates/others/modal'),
		Review: () => import('@/components/main/product-review/review'),
	},
	computed: {
		...mapGetters([
			'loading',
			'showListReview',
			'product_reviews',
			'Product',
		]),
	},
	data() {
		return {
			utils,
			moment,
		};
	},
	methods: {
		...mapActions([
			// 'submitReview',
		]),
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.view-review {
}
</style>
